//#region Imports
import { SETTINGS_AUTH_FORGOT_PASSWORD_URL } from "@anydo/core";
import { fetchAuth } from "../fetchAuth";
import { createAuthHeaders } from "./createAuthHeaders";
//#endregion

/**
 * Used for sending recovery password to given email
 */
export async function forgotAuthUserPassword(email: string): Promise<void> {
  await fetchAuth(SETTINGS_AUTH_FORGOT_PASSWORD_URL, {
    method: "POST",
    headers: createAuthHeaders(),
    body: JSON.stringify({
      email,
    }),
  });
}
